export interface ApiResponse<T> {
  code: number
  message: string
  data: T
  traceId?: string
}

export function isSuccess<T>(response: ApiResponse<T>): boolean {
  return response.code === 200
}

export interface PaginatedData<T> {
  list: T[]
  total: number
  page: number
  pageSize: number
}

export type PaginatedResponse<T> = ApiResponse<PaginatedData<T>>
